import { render } from "./FooterComponent.vue?vue&type=template&id=b7c86ede&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=b7c86ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c86ede"]])

export default __exports__